
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import {IoableParentPageMixin} from "@/router/IoablePageMixin";
import LoaderMixin from "@/components/pages/profile/ProfileManagement/LoaderMixin";
import {defineComponent} from "vue";
import {Controller} from "@/store/modules/hcs/controller/model";
import {DataProfile} from "@/store/modules/hcs/dataProfile/model";
import {ServiceProfile} from "@/store/modules/hcs/serviceProfile/model";
import {ContractProfileTemplate} from "@/store/modules/hcs/contractProfileTemplate/model";
import {DataComponentModel, ServiceComponentModel} from "@/store/modules/hds/Model";

export default defineComponent({
  name: "ProfileManagement",
  components: {TabPageTemplate},
  mixins: [IoableParentPageMixin, LoaderMixin],
  data() {
    return {
      dataProfileView: [],
      controllers: [] as Controller[],
      dataProfiles: [] as DataProfile[],
      serviceProfiles: [] as ServiceProfile[],
      contractProfileTemplates: [] as ContractProfileTemplate[],
      dataComponentModels: [] as DataComponentModel[],
      serviceComponentModels: [] as ServiceComponentModel[],
    };
  },
  methods: {
    async load() {
      const data = await this.loadData();
      this.controllers = data.controllers;
      this.dataProfiles = data.dataProfiles;
      this.serviceProfiles = data.serviceProfiles;
      this.contractProfileTemplates = data.contractProfileTemplates;
      this.dataComponentModels = data.dataComponentModels;
      this.serviceComponentModels = data.serviceComponentModels;
    }
  },
});
